module.exports = __webpack_public_path__ + "static/media/N. Lenore, Willits, CA (2 Buildings)11.03c8a3a5.jpg";